import { render } from "./Signature.vue?vue&type=template&id=53548112"
import script from "./Signature.vue?vue&type=script&lang=js"
export * from "./Signature.vue?vue&type=script&lang=js"

import "./Signature.vue?vue&type=style&index=0&id=53548112&lang=css"

import exportComponent from "/app/tmp/blackhall/V3/v2026.26.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__